import React, { useState, useEffect, useCallback } from 'react';
import {
	Card,
	TranslatedString,
	PrimaryButton,
	useAjax,
	XhrStatus
} from '@bosch/bt-ui';

import './SimMarkUnusablePage.css';
import withErrorHandler from '../../components/ErrorHandler';
import ConfirmDialog from '../../components/ConfirmDialog';
import { prepareLogData } from '../../components/Util';

const SimMarkUnusablePage = (props) => {
	const {
		subTask,
		setSubTask,
		token,
		formValues,
		runAjax,
		returnObj
	} = props;

	const [openConfirm, setConfirmOpen] = useState(false);
	const [disableMark, setMarkUsability] = useState(true);
	const [markStatus, setMarkStatus] = useState(" ");
	const [markButton, setMarkButton] = useState("button-unknow");
	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);

	const onOpenModal = () => setConfirmOpen(true);
	const onCheckUsability = useCallback(
		() => {

			const data = prepareLogData(token,'SIM_Management', 'Is Sim marked Unusable?-> Check ' + formValues.SimId);

			setSubTask('SimMarkUnusablePage');
			runAjax('GET', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/simusability/' + formValues.SimId, null, undefined, { 'Authorization': 'Bearer ' + token.token });
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
		},
		[formValues]
	);

	const onMarkUsability = useCallback(
		() => {
			const data = prepareLogData(token,'SIM_Management', 'Sim-mark-unusable -> Unknown ' + formValues.SimId);
			setSubTask('SimMarkUnusablePage');
			setConfirmOpen(false);
			runAjax('POST', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/simusability/' + formValues.SimId, null, undefined, { 'Authorization': 'Bearer ' + token.token });
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
		},
		[formValues]
	);

	useEffect(() => {
		// Only subTask is "SimMarkUnusablePage", then will take effect on this page
		if (subTask == "SimMarkUnusablePage" && returnObj?.data) {
			const result = returnObj?.data.toString()
			if (result == "Usable") {
				setMarkUsability(false);
				setMarkStatus(result)
				setMarkButton("button-unusable")
			}
			else if (result == "Unusable") {
				setMarkUsability(false);
				setMarkStatus(result)
				setMarkButton("button-usable")
			}
			else {
				setMarkUsability(true);
				setMarkStatus(" ")
				setMarkButton("button-unknow")
			}
		}
		else {
			setMarkUsability(true);
			setMarkStatus(" ")
			setMarkButton("button-unknow")
		}
	}, [returnObj]);

	return (
		<Card
			htmlAttributes={{
				id: "sim-mark-unusable",
				className: 'sim-mark-unusable-page'
			}}
		>
			<div className="caption font-large"><TranslatedString stringId="caption-sim-mark-unusable" /></div>
			<div><TranslatedString stringId="note-sim-mark-unusable" /></div>
			<div className="sim-mark-unusable-body">
				<div className="sim-mark-unusable-submit">
					<div className="sim-input-field">{formValues.SimId}</div>
					<PrimaryButton type="button" onClick={onCheckUsability}>
						<TranslatedString stringId="button-check" />
					</PrimaryButton>
				</div>
				<div className="sim-mark-unusable-status">
					<div><TranslatedString stringId="sim-mark-unusable-status" /></div>
					<div className="usability font-large">{markStatus}</div>
					<PrimaryButton type="button" onClick={onOpenModal} disabled={disableMark}>
						<TranslatedString stringId={markButton} />
					</PrimaryButton>
					<ConfirmDialog openConfirm={openConfirm} setConfirmOpen={setConfirmOpen} onConfirm={onMarkUsability} />
				</div>

			</div>
		</Card>
	);
};

export default withErrorHandler(React.memo(SimMarkUnusablePage));